import type { AnyAction } from '@reduxjs/toolkit';
import type {
  Api,
  EndpointDefinitions,
} from '@reduxjs/toolkit/dist/query/react';
import type {
  QueryKeys,
  RootState,
} from '@reduxjs/toolkit/src/query/core/apiState';
import type { ThunkDispatch } from 'redux-thunk';

export const resetInfiniteScrollQuery = ({
  state,
  dispatch,
  api,
  endpoint,
  tagsToInvalidate,
}: {
  state: RootState<any, any, string>;
  dispatch: ThunkDispatch<any, any, AnyAction>;
  api: Api<any, any, any, any, any>;
  endpoint: QueryKeys<EndpointDefinitions>;
  tagsToInvalidate: { type: string; id?: string }[];
}) => {
  const itemsToReset = api.util.selectInvalidatedBy(state, tagsToInvalidate);

  itemsToReset.forEach((item: { originalArgs: Record<string, unknown> }) => {
    dispatch(
      api.endpoints[endpoint].initiate({
        ...item.originalArgs,
        nextBatchCursor: null,
      })
    );
  });
};

export const handleInfiniteScrollSerializeQueryArgs = ({
  queryArgs,
}: {
  queryArgs: Record<string, any>;
}) => {
  if (!queryArgs) {
    return queryArgs;
  }
  const { nextBatchCursor, ...rest } = queryArgs;
  return rest;
};

export const handleInfiniteScrollQueryMerge = (
  currentCache: Record<string, any>,
  newBatch: Record<string, any>,
  otherArgs: Record<string, any>
) => {
  if (!newBatch.items.length) {
    return;
  }

  const filteredCacheItems = currentCache.items.filter(
    (item) => !newBatch.items.find((newItem) => newItem.id === item.id)
  );

  currentCache.metadata = newBatch.metadata;

  if (otherArgs.arg.nextBatchCursor === null) {
    currentCache.items = newBatch.items;
    return;
  }

  currentCache.items = [...filteredCacheItems, ...newBatch.items];
};

export const shouldForceRefetchInfiniteScrollQuery = ({
  currentArg,
  previousArg,
  endpointState,
}: {
  currentArg: Record<string, any>;
  previousArg: Record<string, any>;
  endpointState: Record<string, any>;
}) => {
  return (
    !(endpointState?.status === 'fulfilled') ||
    currentArg.nextBatchCursor === null ||
    currentArg.nextBatchCursor !== previousArg.nextBatchCursor
  );
};
